import type { HTMLAttributes, ReactNode } from "react"

import { cn } from "~/v2/utils/cn"

const variants = {
  muted: "bg-muted text-muted-foreground",
  success: "bg-success text-success-foreground",
  warning: "bg-warning text-warning-foreground",
} as const

type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  children?: ReactNode
  className?: string
  variant?: keyof typeof variants
}

const Badge = ({
  children,
  className,
  variant = "muted",
  ...props
}: BadgeProps) => {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium",
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}

export default Badge
